import React from 'react';
import { useIsMobile } from '../hooks/useDeviceType';

// Invoices
import ReceivedInvoices from './portal/ReceivedInvoices';
import SentInvoices from './portal/SentInvoices';
import MobileInvoices from './portal/MobileInvoices';

// ToDo
import TodoList from './portal/TodoList';
import MobileToDo from './portal/MobileToDo';

// Contacts
import Contacts from './portal/Contacts';
import MobileContacts from './portal/MobileContacts';

// Payments
import Payments from './portal/Payments';
import MobilePayments from './portal/MobilePayments';

// Send Invoice
import SendInvoice from './portal/SendInvoice';
import MobileSendInvoice from './portal/MobileSendInvoice';

// Chat
import Chat from './portal/Chat';
import MobileChat from './portal/MobileChat';

// Settings
import Settings from './portal/Settings';
import MobileSettings from './portal/MobileSettings';

// Integrations
import Integrations from './portal/Integrations';

/**
 * Responsive Invoices - shows MobileInvoices on mobile, ReceivedInvoices on desktop
 */
export const ResponsiveInvoices = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileInvoices {...props} />;
  }
  
  // On desktop, default to ReceivedInvoices (user can navigate to Sent via sidebar)
  return <ReceivedInvoices {...props} />;
};

/**
 * Responsive ToDo - shows MobileToDo on mobile, TodoList on desktop
 */
export const ResponsiveToDo = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileToDo {...props} />;
  }
  
  return <TodoList {...props} />;
};

/**
 * Responsive Contacts - shows MobileContacts on mobile, Contacts on desktop
 */
export const ResponsiveContacts = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileContacts {...props} />;
  }
  
  return <Contacts {...props} />;
};

/**
 * Responsive Payments - shows MobilePayments on mobile, Payments on desktop
 */
export const ResponsivePayments = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobilePayments {...props} />;
  }
  
  return <Payments {...props} />;
};

/**
 * Responsive Send Invoice - shows MobileSendInvoice on mobile, SendInvoice on desktop
 */
export const ResponsiveSendInvoice = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileSendInvoice {...props} />;
  }
  
  return <SendInvoice {...props} />;
};

/**
 * Responsive Chat - shows MobileChat on mobile, Chat on desktop
 */
export const ResponsiveChat = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileChat {...props} />;
  }
  
  return <Chat {...props} />;
};

/**
 * Responsive Settings - shows MobileSettings on mobile, Settings on desktop
 */
export const ResponsiveSettings = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileSettings {...props} />;
  }
  
  return <Settings {...props} />;
};

/**
 * Responsive Integrations - shows Integrations component (same on mobile and desktop for now)
 */
export const ResponsiveIntegrations = (props) => {
  return <Integrations {...props} />;
};

export default {
  ResponsiveInvoices,
  ResponsiveToDo,
  ResponsiveContacts,
  ResponsivePayments,
  ResponsiveSendInvoice,
  ResponsiveChat,
  ResponsiveSettings,
  ResponsiveIntegrations
};

